import { BACKEND_KEYS } from '../../common/consts/app-keys.const';
import {
  HttpFactoryService,
  EnhancedWithAuthHttpService
} from '../../common/services';

/** A developer key as the store lists it: never the key itself. */
export interface IApiKey {
  id: number;
  name: string;
  product: string;
  prefix: string;
  createdAt: string;
  lastUsedAt: string | null;
}

/** A key just made: the one time the key itself is shown. */
export interface ICreatedApiKey extends IApiKey {
  key: string;
}

class DeveloperService {
  httpService: EnhancedWithAuthHttpService;

  constructor(private httpFactory: HttpFactoryService) {
    this.httpService = httpFactory.createAuthHttpService();
  }

  async listKeys(product: string): Promise<IApiKey[]> {
    const result: IApiKey[] | void = await this.httpService.get(
      `${BACKEND_KEYS.DEVELOPER_KEYS}?product=${encodeURIComponent(product)}`
    );
    return result ?? [];
  }

  async createKey(product: string, name: string): Promise<ICreatedApiKey> {
    const result: ICreatedApiKey | void = await this.httpService.post(
      BACKEND_KEYS.DEVELOPER_KEYS,
      { product, name }
    );
    if (!result) throw new Error('Error while making a key');
    return result;
  }

  async revokeKey(id: number): Promise<void> {
    await this.httpService.delete(`${BACKEND_KEYS.DEVELOPER_KEYS}/${id}`);
  }
}

const developerService = new DeveloperService(new HttpFactoryService());

export { developerService };
